export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13837.3c46d3c1.jpg";